<dx-data-grid [dataSource]="data" [showBorders]="false" [columnAutoWidth]="true"[errorRowEnabled]="false"
 [rtlEnabled]="currentLang=='ar'?true:false"
 [columnHidingEnabled]="true"
  [showColumnLines]="false"
  [rowAlternationEnabled]="true"
  [showRowLines]="false"
  [showBorders]="false" style="margin: 1rem 0rem" (onEditingStart)="updateRow($event)">
  <dxo-paging [pageSize]="3"> </dxo-paging>
  <dxo-editing mode="form" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="true" [texts]="button">
  </dxo-editing>
  <dxi-column dataField="fromAge" caption="{{'HolidayWorkSystem.fromAge'|translate}}">
  </dxi-column>
  <dxi-column dataField="toAge" caption="{{'HolidayWorkSystem.toAge'|translate}}"></dxi-column>
  <dxi-column dataField="countDay" caption="{{'HolidayWorkSystem.countDay'|translate}}"></dxi-column>
  <dxi-column dataField="holidaySystemSubDetails" cellTemplate="tagBoxTemplate" caption="{{'HolidayWorkSystem.holidaysname'|translate}}"></dxi-column>
  <div *dxTemplate="let cellInfo of 'tagBoxTemplate' ; let i = index">
    <ng-container *ngFor="let ele of cellInfo.value">
      <ng-container *ngFor="let holiday of holidaydropdown">
        <span *ngIf="holiday.id==ele.holidayTypeId">{{holiday.nameAr}},</span>
      </ng-container>
    </ng-container>
  </div>
</dx-data-grid>